import { useToast } from "@/components/ui/use-toast";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { useContractorsAssignmentsContext } from "../components/ContractorsAssignmentsContext";

export const useRemoveContractorAssignmentMutation = () => {
  const { t } = useTranslation();
  const { toast } = useToast();
  const queryClient = useQueryClient();

  const { projectContractorsMainQueryKey, ProjectContractorsService } =
    useContractorsAssignmentsContext();

  return useMutation<unknown, Error, string>({
    mutationFn: (contractorAssignmentId: string) =>
      ProjectContractorsService.delete(contractorAssignmentId),
    onSuccess: () => {
      toast({
        title: t("contractorsAssignments.success.delete"),
      });
      queryClient.invalidateQueries({
        queryKey: [projectContractorsMainQueryKey],
      });
    },
    onError: (error) => {
      toast({
        title: t("contractorsAssignments.errors.delete"),
        description: error.message,
        variant: "destructive",
      });
    },
  });
};
